import { Assignment } from "@mui/icons-material";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const Relatorios = () => {
  const navigate = useNavigate();

  const relatorios = [
    {
      id: "obrigacoes-enviadas",
      titulo: "Obrigações enviadas",
      //descricao: "Relatório de obrigações que foram enviadas aos clientes",
      icon: Assignment,
      path: "/relatorios/obrigacoes-enviadas",
    },
    // Futuros relatórios podem ser adicionados aqui
    // {
    //   id: "tarefas-concluidas",
    //   titulo: "Tarefas concluídas",
    //   descricao: "Relatório de tarefas finalizadas por período",
    //   icon: "✅",
    //   path: "/relatorios/tarefas-concluidas",
    // },
  ];

  const handleRelatorioClick = (path) => {
    navigate(path);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600, color: "#333" }}>
          Relatórios
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {relatorios.map((relatorio) => (
          <Grid item xs={12} sm={6} md={4} key={relatorio.id}>
            <Card
              sx={{
                cursor: "pointer",
                transition:
                  "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 4,
                },
              }}
              onClick={() => handleRelatorioClick(relatorio.path)}
            >
              <CardContent sx={{ textAlign: "center", p: 3 }}>
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                  <relatorio.icon
                    sx={{
                      fontSize: "3rem",
                      color: "primary.main",
                    }}
                  />
                </Box>
                <Typography variant="h6" gutterBottom>
                  {relatorio.titulo}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {relatorio.descricao}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Relatorios;
